import type { FaireProductEntity } from "../../entity_types/product";

export const p_x6bfnjg7d2: FaireProductEntity = {
  token: "p_x6bfnjg7d2",
  type: "product",
  name: "Spring Song - Letter Writing Set",
  brandToken: "b_20vdpzwnor",
  brandName: "Laughing Elephant",
  imageUrl:
    "https://cdn.faire.com/fastly/f0854dd21970a9c7915c657c3ecd267b89c3aa4ae46313d8a1e8c6360e26835d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f8fea953c61b8fdd34e9f21ae76e16d4be9e6d78431afaf603b5c1c06b97c8e.png",
    "https://cdn.faire.com/fastly/a0a02570593de1584f42c6ebf046af8f07659cf8fcccc993fba60a4d2c194e99.png",
    "https://cdn.faire.com/fastly/c3314546640a176321cf84078d8cbe781cc1d20747b3410563c9c85f401a9c8c.jpeg",
    "https://cdn.faire.com/fastly/ce05dd735795f0987904b498c36d200dcdb10630798f0de3cd8c332d5724ef58.jpeg",
  ],
  priceDollars: 9,
  description:
    "• 12 adorned stationery sheets with 6 similarly adorned envelopes, bound\n\n• Fountain Pen Friendly🖋️\n\nEmbrace the art of letter writing with this enchanting stationery set! We've adorned these letters and matching envelopes with apple blossoms and singing birds. Whether you're writing a note to thank, encourage, congratulate, or simply express \"I'm here and I'm thinking about you,\" the act of writing becomes a pleasure for both the sender and the recipient! Adding your message to attractive stationery not only adds a personal touch but also enhances your words with visual beauty.\n\nThis product is custom-designed and printed at our location in Seattle.",
  tags: [],
  msrpDollars: 19.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:32.724Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
